import { InfoGridFuelCategory } from '@ahd/shared/types/ahd-fleet-api/fleet-car/enums';
import { FdTypes } from '@ahd/shared/types/ahd-fleet-api/fleet-car/fd/types';

import { Modules } from '../modules/_definition/types';
import { type Translations } from './translations';

const enUS: Translations = {
    buttons: {
        acceptMaps: 'Click here to agree to the use of Google Maps!',
        advancedSearch: 'Advanced search',
        back: 'Back',
        backToSearch: 'Back to search',
        chooseVehicleHeading: 'Choose vehicle',
        clear: 'Clear',
        close: 'Close',
        collapse: 'Collapse',
        continue: 'Continue',
        expand: 'Expand',
        filters: 'Filters',
        loadingView: 'Loading view...',
        loadMoreResults: 'Loading more results...',
        loadMoreVehicles: 'Loading new vehicles...',
        loadMoreVehiclesVariant: 'Show more vehicles',
        nextPage: 'Next',
        no: 'No',
        prevPage: 'Previous',
        rateCalculator: 'Rate calculator',
        resetData: 'Reset Data',
        resetFilter: 'Reset filter',
        search: 'Search',
        showAllLocations: 'Show all locations',
        showAllVehicles: 'Show all {0} vehicles',
        skip: 'Skip',
        vehicle: 'Vehicle',
        vehicles: 'Vehicles',
        yes: 'Yes',
    },
    car: {
        ez: 'First registration',
        km: 'Mileage',
        ident: 'Order number',
        kategorie: 'Category',
        leergewicht: 'Empty weight',
        typ: 'Type',
        types: {
            singular: {
                '-': '(unknown)',
                '1': 'New vehicle',
                '2': 'Used vehicle',
                '4': 'Demonstration vehicle',
                '8': 'Rental vehicle',
                '16': 'Special vehicle',
                '32': 'Day admission',
            },
            plural: {
                '-': '',
                '1': 'New vehicles',
                '2': 'Used vehicles',
                '4': 'Demonstration vehicles',
                '8': 'Rental vehicles',
                '16': 'Special vehicles',
                '32': 'Day admissions',
            },
        },
        sitze: 'Seats',
        tueren: 'Doors',
        engine: {
            effizienz: 'Efficiency',
            hubraum: 'Displacement',
            leistung: 'Power',
            motor: 'Engine',
            verbrauch: {
                '0': 'Consumption comb.',
                '1': 'CO₂ emission',
                '2ndDrive': '2nd Drive',
                combined: 'Combined',
                effizienz: 'Efficiency',
                schadstoff: 'Emission class',
                heading: 'Consumption and emission',
                inner: 'In town',
                outer: 'Out of town',
                slow: 'City',
                medium: 'Outskirts',
                fast: 'Country road',
                veryFast: 'Highway',
                range: 'Range',
                city: 'City',
                protocol: 'Consumption data',
                protocolBy: 'Consumption data according to {0}',
                nefz: 'NEDC',
                wltp: 'WLTP',
                noNEFZAvailable: 'No NEDC values available',
            },
        },
        garantie: 'Warranty',
        getriebe: 'Transmission',
        siegel: 'Seal',
        standort: 'Location',
        farbe: 'Color',
        antrieb: 'Drive',
        verfuegbarkeit: 'Availability',
        verfuegbarAb: 'Available at',
        aktion: 'campaign vehicle',
        nowAvailable: 'Now available',
        lieferzeit: 'Delivery time',
        isOrderCar: 'Order vehicle',
        onlyCommercial: 'Only commercial',
        preis: {
            inclMwst: 'incl. {0} VAT',
            exclMwst: 'excl. VAT',
        },
        aus: {
            categories: {
                kopf: '',
                highlights: 'Highlights',
                technik: 'Technology and safety',
                multimedia: 'Multimedia',
                assistenz: 'Assistance',
                innen: 'Interior',
                sitze: 'Seats and Pads',
                aussen: 'Exterior',
                scheinwerfer: 'Headlights and lamps',
                raeder: 'Wheels and tires',
                pakete: 'Packets',
                sonstiges: 'Other',
                fussnoten: 'Foot notes',
                fuss: '',
            },
            assistenz: {
                title: 'Assistance',
                25: 'Cruise control',
                26: 'Parking sensors',
                48: 'Self-steering park system',
                332: 'Adaptive cruise control',
                402: 'Rear camera',
                514: 'Lane change assistant',
                515: 'Lane keeping assistant',
                1145: 'Traffic sign recognition',
            },
            aussen: {
                title: 'Exterior',
                34: 'Sunroof',
                41: 'Xenon headlights',
                71: 'Alloy wheels',
                88: 'Hitch',
                238: 'Panoramic/glass roof',
                1140: 'LED headlights',
            },
            innen: {
                title: 'Interior',
                22: 'Automatic air conditioning',
                23: 'Auxiliary heating',
                24: 'Navigation system',
                27: 'Electric windows',
                29: 'Heated seats',
                36: 'Electric seat adjustment',
                81: 'Leather interior',
                278: 'Sport seats',
                1119: 'Bluetooth',
            },
            showMore: {
                btn: 'Show all accessoires',
                subtitle: 'There is more to discover!',
            },
            sonstiges: {
                title: 'Other',
                61: 'Four-wheel drive',
            },
        },
    },
    carSearch: {
        foundCar: 'vehicle found',
        foundCars: 'vehicles found',
        forFilters: 'for filters',
        grid: 'Grid',
        heading: 'New and used vehicles',
        heading2: 'Used vehicles',
        list: 'List',
        page: 'Page',
        sort: 'Sort',
        view: 'View',
    },
    carTile: {
        priceGrid: {
            diff25a: '§ 25a (UStG)',
            diff25aDesc: 'Additional tax cannot be shown',
        },
        verbrauchText: {
            combined: 'comb.',
            discharged: 'discharged',
            weighted: 'wei.',
        },
    },
    carView: {
        accessoires: {
            contactPlusAccessoiresPrice: '(+ Accessories)',
            special: 'Special accessoires',
            standard: 'Standard accessoires',
            title: 'Here you can find accessories for your {0} {1}',
            titleSelected: 'Your selected accessories',
            withAccessoiresPrice: 'plus {0} € for accessories',
        },
        contactTab: {
            approach: 'Approach',
            call: 'Call',
            mail: 'Mail',
            message: 'Request',
            phone: 'Phone',
        },
        contact: {
            abort: 'Abort',
            bdkAddInsurances: 'Additional insurance',
            bdkCreditCheck: 'Preliminary credit check',
            bdkSubmit: 'Submit request',
            bdkVendorContact: '(Vendor Request)',
            title: 'Contact',
            contactPerson: 'Your contact person',
            copyTel: {
                error: 'Error',
                success: 'Copied',
            },
            fd: 'Your financial service',
            requestType: 'Request type',
            requestTypes: {
                '0': 'Send request',
                '0a': 'Send request to',
                '0b': 'Financing request',
                '0c': 'Leasing request',
                '10': 'Request appointment',
                '10a': 'Request appointment at',
                '12': 'Request call back',
                '12a': 'Request call back at',
                '20': 'Request test drive',
                '20a': 'Request test drive at',
                '27': 'Trade in',
                '27a': 'Trade in at',
                '0Short': 'request',
                '10Short': 'appointment',
                '12Short': 'call back',
                '20Short': 'test drive',
                '27Short': 'Trade in',
            },
            name: 'Name',
            mail: 'Mail',
            priceAlert: 'Price alert',
            priceAlertInfo: 'Receive an e-mail if the price of this vehicle falls below your desired price',
            phone: 'Phone',
            testDriveWithContactRequest: 'Test drive desired',
            date: 'Desired date',
            dateWithContactRequest: 'Desired date for test drive',
            message: 'Your request',
            disclaimer: 'I have read the {0}',
            disclaimerLink: 'Disclaimer',
            reset: 'Start over',
            requestSuccess: 'The request was successful',
            send: 'Send request',
            sending: 'Sending...',
            errorSending: 'Error sending request',
            errorSkipStep: 'This step cannot be skipped',
            successSending: 'Request sent successfully',
            tryAgain: 'Please try again in some minutes',
            subjectPrefix: 'Vehicle request for vehicle {0}',
            subjectPrefixAbo: 'AutoAbo request for vehicle {0}',
            errors: {
                reCaptcha: 'ReCAPTCHA verification failed',
                requestType: 'Request type missing',
                name: 'Name missing',
                mailMissing: 'Mail missing',
                mailInvalid: 'Mail in wrong format',
                phone: 'Phone missing',
                date: 'Date missing',
                message: 'Request missing',
                acceptDisclaimer: 'Please accept disclaimer',
            },
        },
        newTabs: {
            0: {
                title: 'Accessoires',
                url: 'accessoires',
            },
            1: {
                title: 'Description',
                url: 'description',
            },
            2: {
                title: 'Consumption data',
                url: 'consumption-data',
            },
            3: {
                title: 'Location',
                url: 'location',
            },
        },
        calculator: {
            bonitat: 'Creditworthiness required',
            businessFinancingRequest: 'business request',
            button: 'Request now for {0} / month',
            buttonBDK: 'Request directly from BDK for {0} / month',
            buttonVendor: 'Request directly from vendor for {0} / month',
            creditCheck: {
                companyAge: 'Age of the company (in years)',
                insolvency: 'I have insolvency proceedings running against me or a discharge of residual debt:',
                isBusinessOwner: 'I have registered a business:',
                isBusinessVehicle: 'I also want to use the vehicle commercially:',
                monthlyExpenses: 'Total monthly expenditure:',
                monthlyIncome: 'Total monthly net income:',
                negativeSchufa: 'I have negative credit and I make payments to debt collection companies:',
                peopleInHousehold: 'People in the household:',
                title: 'Pre-assessment for the credit',
                titleInfo: '(voluntary)',
            },
            fd: {
                [FdTypes.ABO]: {
                    available: 'Available',
                    bank: 'Mobility partner',
                    damageParticipation: 'Deductible',
                    deliveryOption: 'Delivery options',
                    deliveryOption_faaren_delivery: 'Delivery by Faaren',
                    deliveryOption_no_delivery: 'No delivery',
                    deliveryOption_partner_delivery: 'Delivery by provider',
                    deliveryTime: 'Delivery time after order',
                    detail0: 'All inclusive except for fuel',
                    detail1: 'Can be canceled monthly at the end of the minimum term',
                    downPayment: 'Down payment',
                    duration: 'Term',
                    extraMileageCosts: 'Extra mileage costs',
                    fixedDuration: 'Monthly changeable',
                    immediatelyAvailable: 'Now available',
                    mileage: 'Monthly mileage',
                    minimumAge: 'Minimum age',
                    minLicenseDuration: 'Minimum driving license period',
                    monthlyRateGross: 'Monthly rate gross',
                    monthlyRateNet: 'Monthly rate net',
                    pickUpOption: 'Pick up options',
                    pickUpOption_faaren_delivery: 'Pick up from Faaren',
                    pickUpOption_no_delivery: 'No delivery',
                    pickUpOption_partner_delivery: 'Pick up from provider',
                    provider: 'Provider',
                    title: 'Auto-Abo',
                    totalGross: 'Total amount gross',
                    totalNet: 'Total amount net',
                    type: 'Type',
                    vehiclePrice: 'Vehicle new price',
                    verb: 'rent',
                },
                [FdTypes.BUSINESS_LEASING]: {
                    annualPercentageRate: 'Annual percentage rate',
                    available: 'Available',
                    bank: 'Provider bank',
                    destinationChargesGross: 'Destination charge gross',
                    destinationChargesNet: 'Destination charge net',
                    detail0: 'Fixed monthly installment',
                    detail1: 'Return of the vehicle at the end of the term',
                    downPayment: 'Special payment',
                    duration: 'Term',
                    extraMileageCosts: 'Extra mileage costs',
                    gapInsurance: 'GAP Insurance',
                    gapInsuranceAmount: 'Amount GAP Insurance',
                    lowMileageCompensation: 'Low mileage compensation',
                    mileage: 'Annual mileage',
                    monthlyRateGross: 'Monthly rate gross',
                    monthlyRateNet: 'Monthly rate net',
                    nominalInterestRate: 'Nominal interest rate',
                    provider: 'Provider',
                    registrationFeesGross: 'Registration fees gross',
                    registrationFeesNet: 'Registration fees net',
                    shortTitle: 'business',
                    title: 'Business leasing',
                    totalGross: 'Total amount gross',
                    totalNet: 'Total amount net',
                    type: 'Type',
                    vehiclePrice: 'Vehicle price',
                    verb: 'lease',
                },
                [FdTypes.FINANCING_AUTOCREDIT]: {
                    annualPercentageRate: 'Annual percentage rate',
                    available: 'Available',
                    bank: 'Provider bank',
                    closingCosts: 'Closing costs',
                    destinationChargesGross: 'Destination charge gross',
                    destinationChargesNet: 'Destination charge net',
                    detail0: 'Low monthly rate',
                    detail1: 'Final installment with several closing options',
                    downPayment: 'Down payment',
                    duration: 'Term',
                    finalInstallment: 'Final installment',
                    gapInsurance: 'GAP Insurance',
                    gapInsuranceAmount: 'Amount GAP Insurance',
                    gapInsurance_GAP: 'GAP',
                    gapInsurance_GAP_desc: 'Proceed with GAP insurance.',
                    gapInsurance_GAP_PLUS: 'GAP Plus',
                    gapInsurance_GAP_PLUS_desc: 'Proceed with GAP Plus insurance.',
                    gapInsurance_NONE: 'No',
                    gapInsurance_NONE_desc: 'Proceed without additional insurance.',
                    mileage: 'Annual mileage',
                    monthlyRateGross: 'Monthly rate gross',
                    monthlyRateNet: 'Monthly rate net',
                    nominalInterestRate: 'Nominal interest rate',
                    paymentProtectionInsurance: 'Credit protection insurance',
                    paymentProtectionInsuranceAmount: 'Amount credit protection insurance',
                    paymentProtectionInsurance_NONE: 'No',
                    paymentProtectionInsurance_RSV: 'CPI',
                    paymentProtectionInsurance_RSVPLUS: 'CPI Plus',
                    provider: 'Provider',
                    registrationFeesGross: 'Registration fees gross',
                    registrationFeesNet: 'Registration fees net',
                    title: 'Financing',
                    totalGross: 'Total amount gross',
                    totalNet: 'Total amount net',
                    typeOfNominalInterestRate: 'Type of nominal interest rate',
                    type: 'Type',
                    vehiclePrice: 'Vehicle price',
                    verb: 'finance',
                },
                [FdTypes.FINANCING_CLASSICCREDIT]: {
                    annualPercentageRate: 'Annual percentage rate',
                    available: 'Available',
                    bank: 'Provider bank',
                    closingCosts: 'Closing costs',
                    destinationChargesGross: 'Destination charge gross',
                    destinationChargesNet: 'Destination charge net',
                    detail0: 'Low monthly rate',
                    detail1: 'Final installment with several closing options',
                    downPayment: 'Down payment',
                    duration: 'Term',
                    finalInstallment: 'Final installment',
                    gapInsurance: 'GAP Insurance',
                    gapInsuranceAmount: 'Amount GAP Insurance',
                    gapInsurance_GAP: 'GAP',
                    gapInsurance_GAP_desc: 'Proceed with GAP insurance.',
                    gapInsurance_GAP_PLUS: 'GAP Plus',
                    gapInsurance_GAP_PLUS_desc: 'Proceed with GAP Plus insurance.',
                    gapInsurance_NONE: 'No',
                    gapInsurance_NONE_desc: 'Proceed without additional insurance.',
                    mileage: 'Annual mileage',
                    monthlyRateGross: 'Monthly rate gross',
                    monthlyRateNet: 'Monthly rate net',
                    nominalInterestRate: 'Nominal interest rate',
                    paymentProtectionInsurance: 'Credit protection insurance',
                    paymentProtectionInsuranceAmount: 'Amount credit protection insurance',
                    paymentProtectionInsurance_NONE: 'No',
                    paymentProtectionInsurance_RSV: 'CPI',
                    paymentProtectionInsurance_RSVPLUS: 'CPI Plus',
                    provider: 'Provider',
                    registrationFeesGross: 'Registration fees gross',
                    registrationFeesNet: 'Registration fees net',
                    title: 'Financing',
                    totalGross: 'Total amount gross',
                    totalNet: 'Total amount net',
                    typeOfNominalInterestRate: 'Type of nominal interest rate',
                    type: 'Type',
                    vehiclePrice: 'Vehicle price',
                    verb: 'finance',
                },
                [FdTypes.FINANCING_INDIVIDUAL]: {
                    annualPercentageRate: 'Annual percentage rate',
                    available: 'Available',
                    bank: 'Provider bank',
                    closingCosts: 'Closing costs',
                    destinationChargesGross: 'Destination charge gross',
                    destinationChargesNet: 'Destination charge net',
                    detail0: 'Low monthly rate',
                    detail1: 'Final installment with several closing options',
                    downPayment: 'Down payment',
                    duration: 'Term',
                    finalInstallment: 'Final installment',
                    gapInsurance: 'GAP Insurance',
                    gapInsuranceAmount: 'Amount GAP Insurance',
                    gapInsurance_GAP: 'GAP',
                    gapInsurance_GAP_desc: 'Proceed with GAP insurance.',
                    gapInsurance_GAP_PLUS: 'GAP Plus',
                    gapInsurance_GAP_PLUS_desc: 'Proceed with GAP Plus insurance.',
                    gapInsurance_NONE: 'No',
                    gapInsurance_NONE_desc: 'Proceed without additional insurance.',
                    mileage: 'Annual mileage',
                    monthlyRateGross: 'Monthly rate gross',
                    monthlyRateNet: 'Monthly rate net',
                    nominalInterestRate: 'Nominal interest rate',
                    paymentProtectionInsurance: 'Credit protection insurance',
                    paymentProtectionInsuranceAmount: 'Amount credit protection insurance',
                    paymentProtectionInsurance_NONE: 'No',
                    paymentProtectionInsurance_RSV: 'CPI',
                    paymentProtectionInsurance_RSVPLUS: 'CPI Plus',
                    provider: 'Provider',
                    registrationFeesGross: 'Registration fees gross',
                    registrationFeesNet: 'Registration fees net',
                    title: 'Financing',
                    totalGross: 'Total amount gross',
                    totalNet: 'Total amount net',
                    typeOfNominalInterestRate: 'Type of nominal interest rate',
                    type: 'Type',
                    vehiclePrice: 'Vehicle price',
                    verb: 'finance',
                },
                [FdTypes.FINANCING_VARIO]: {
                    annualPercentageRate: 'Annual percentage rate',
                    available: 'Available',
                    bank: 'Provider bank',
                    closingCosts: 'Closing costs',
                    destinationChargesGross: 'Destination charge gross',
                    destinationChargesNet: 'Destination charge net',
                    detail0: 'Low monthly rate',
                    detail1: 'Final installment with several closing options',
                    downPayment: 'Down payment',
                    duration: 'Term',
                    finalInstallment: 'Final installment',
                    gapInsurance: 'GAP Insurance',
                    gapInsuranceAmount: 'Amount GAP Insurance',
                    gapInsurance_GAP: 'GAP',
                    gapInsurance_GAP_desc: 'Proceed with GAP insurance.',
                    gapInsurance_GAP_PLUS: 'GAP Plus',
                    gapInsurance_GAP_PLUS_desc: 'Proceed with GAP Plus insurance.',
                    gapInsurance_NONE: 'No',
                    gapInsurance_NONE_desc: 'Proceed without additional insurance.',
                    mileage: 'Annual mileage',
                    monthlyRateGross: 'Monthly rate gross',
                    monthlyRateNet: 'Monthly rate net',
                    nominalInterestRate: 'Nominal interest rate',
                    paymentProtectionInsurance: 'Credit protection insurance',
                    paymentProtectionInsuranceAmount: 'Amount credit protection insurance',
                    paymentProtectionInsurance_NONE: 'No',
                    paymentProtectionInsurance_RSV: 'CPI',
                    paymentProtectionInsurance_RSVPLUS: 'CPI Plus',
                    provider: 'Provider',
                    registrationFeesGross: 'Registration fees gross',
                    registrationFeesNet: 'Registration fees net',
                    title: 'Financing',
                    totalGross: 'Total amount gross',
                    totalNet: 'Total amount net',
                    typeOfNominalInterestRate: 'Type of nominal interest rate',
                    type: 'Type',
                    vehiclePrice: 'Vehicle price',
                    verb: 'finance',
                },
                [FdTypes.PRIVATE_LEASING]: {
                    annualPercentageRate: 'Annual percentage rate',
                    available: 'Available',
                    bank: 'Provider bank',
                    destinationChargesGross: 'Destination charge gross',
                    destinationChargesNet: 'Destination charge net',
                    detail0: 'Fixed monthly installment',
                    detail1: 'Return of the vehicle at the end of the term',
                    downPayment: 'Special payment',
                    duration: 'Term',
                    extraMileageCosts: 'Extra mileage costs',
                    gapInsurance: 'GAP Insurance',
                    gapInsuranceAmount: 'Amount GAP Insurance',
                    lowMileageCompensation: 'Low mileage compensation',
                    mileage: 'Annual mileage',
                    monthlyRateGross: 'Monthly rate gross',
                    monthlyRateNet: 'Monthly rate net',
                    nominalInterestRate: 'Nominal interest rate',
                    provider: 'Provider',
                    registrationFeesGross: 'Registration fees gross',
                    registrationFeesNet: 'Registration fees net',
                    shortTitle: 'private',
                    title: 'Private leasing',
                    totalGross: 'Total amount gross',
                    totalNet: 'Total amount net',
                    type: 'Type',
                    vehiclePrice: 'Vehicle price',
                    verb: 'lease',
                },
            },
            gapInsuranceStepperTitle: 'Add insurance',
            insuranceInfoText: '* Insurances like a credit insurance protection (CPI){0}can be arranged with the vendor on demand.',
            orderRequest: {
                orderBdkDescription: 'Send your request directly to Bank Deutsches Kraftfahrzeuggewerbe (BDK).',
                orderBdkInfo: '(Only possible for financing requests with successfull credit pre-approval check)',
                orderBdkNotAvailable: 'This service is not available at the moment.',
                orderVendorDescription: 'Send your request directly to the vendor.',
            },
            title: {
                block: 'Simple and flexible financing or leasing',
                blockWithAbo: 'Simple and flexible financing, leasing or subscribe',
                financing: 'Financing',
                leasing: 'Leasing',
                rateSettings: 'Your rate settings',
                summary: {
                    financing: 'Your financing offer',
                    leasing: 'Your leasing offer',
                    autoAbo: 'Your Auto-Abo offer',
                },
                typeChooser: 'Pick your poison',
            },
        },
        downloadExposee: 'Download',
        exposeeError: 'An error occurred during generation!\nPlease try again later',
        exposeeLoading: 'One moment please, the exposé is generated',
        exposeeReady: 'The exposé is now ready for download',
        locationUsers: 'Your contact persons',
        locationUsersContact: 'Contact',
        share: {
            copy: 'Copy link',
            mail: 'Mail',
            title: 'Share',
        },
        showExposee: 'Exposé',
        similarCars: 'Similar cars',
        tabs: {
            0: 'Vehicle data',
            1: 'Description',
            2: 'Location',
        },
        tradeIn: {
            heading: 'Trade-in?',
            content: 'Would you like to trade in your current vehicle and quickly find out the non-binding market value?',
            button: 'Calculate now',
        },
        verbrauch: {
            combined: 'Combined',
            combinedWeighted: 'Combined (weighted)',
            combinedWeightedShort: 'Comb. wei.',
            co2class: 'CO₂ class',
            co2classWeighted: 'CO₂ class (weighted)',
            co2costs: 'Possible CO₂ costs over the next 10 years (at 15,000 km / year):',
            co2costsBaseLow: 'assuming low ⌀ CO₂ price of {0}',
            co2costsBaseMedium: 'assuming medium ⌀ CO₂ price of {0}',
            co2costsBaseHigh: 'assuming high ⌀ CO₂ price of {0}',
            co2costsLow: 'low CO₂ price',
            co2costsMedium: 'medium CO₂ price',
            co2costsHigh: 'high CO₂ price',
            discharged: 'at discharged\nbattery',
            energycosts: 'Energy costs per year (at 15,000 km / year)',
            emission: 'Emission',
            emissionWeighted: 'Emission (weighted)',
            emissionWeightedShort: 'Emiss. wei.',
            euronorm: 'Emission class',
            extraHigh: 'Highway',
            fuelCostsYear: {
                [InfoGridFuelCategory.BIFUEL]: 'Annual average fuel price',
                [InfoGridFuelCategory.CELL]: 'Annual average hydrogen price',
                [InfoGridFuelCategory.DEFAULT]: 'Annual average fuel price',
                [InfoGridFuelCategory.ELECTRO]: 'Annual average electricity price',
                [InfoGridFuelCategory.GAS]: 'Annual average fuel price',
                [InfoGridFuelCategory.OTHERHYBRID]: 'Annual average fuel price',
                [InfoGridFuelCategory.PLUGINHYBRID]: 'Annual average fuel price',
            },
            fuelCostsYearState: 'Price: {0} | Status: {1}',
            header: 'Fuel Consumption',
            headerDischarged: 'Fuel consumption with discharged battery',
            headerElectro: 'Power consumption',
            headerPlugIn: 'Power consumption in all-electric mode',
            high: 'Country road',
            medium: 'Outskirts',
            motor: 'Motor',
            low: 'City',
            range: 'Electrical Range',
            title: 'Consumption and emission',
            weighted: 'weighted',
        },
    },
    common: {
        and: 'and',
        at: 'at',
        atThe: 'at the',
        brutto: 'gross',
        in: 'in',
        netto: 'net',
        notAvailable: 'Not available',
    },
    filter: {
        special: 'campaign vehicles',
        aktion: 'campaign vehicles',
        specialActive: 'Only campaign vehicles',
        exteriorColor: 'Color',
        make: 'Manufacturer',
        hersteller0: 'Manufacturer',
        model: 'Model',
        modell0: 'Model',
        condition: 'Type',
        akttypList: 'Type',
        stime: 'Storage time',
        location: 'Location',
        seller: 'Location',
        Standort: 'Location',
        locationMap: {
            buttonText: 'Map view',
            dialog: {
                filterButton: 'Show {0} vehicles',
                filterAllButton: 'Show all vehicles',
                title: 'Filter Locations',
                selectAll: 'Select all',
            },
        },
        category: 'Assembling',
        aufbau: 'Assembling',
        aufbauten: 'Assemblings',
        usedCarSeal: 'Seal',
        hasSeal: 'Seal',
        price: 'Price',
        priceFrom: 'Price from',
        priceTo: 'Price till',
        rate: 'Monthly rate',
        rateFrom: 'Monthly rate from',
        rateTo: 'Monthly rate till',
        firstRegistration: 'First registration',
        firstRegistrationFrom: 'First registration from',
        firstRegistrationTo: 'First registration till',
        mileage: 'Mileage',
        mileageFrom: 'Mileage from',
        mileageTo: 'Mileage till',
        power: 'Power',
        powerFrom: 'Power from',
        powerTo: 'Power till',
        fuel: 'Engine',
        motoren: 'Engine',
        gearbox: 'Transmission',
        available: 'Now available',
        sofort: 'Now available',
        availableActive: 'Only now available',
        tags: 'Campaign',
        tagsExclude: 'Exclude campaign',
        fd: 'Financial services',
        accessoirs: 'Features',
        accessoirsHeading: 'Choose Features',
        searchText: 'Full-text search',
        availabileDate: 'Date of availability',
        asc: 'ascendent',
        desc: 'descendent',
        Alle: 'All',
        alle: 'all',
        from: 'from',
        to: 'to',
        moreThan: 'More than',
        vehicleClass: 'Vehicle type',
        ort: 'Location',
        order: 'Order',
        page: 'Page',
        pageSize: 'Count',
        sort: 'Sort',
        set: 'set',
        setFilter: 'Filter set',
        ignoreStandort: 'Exclude location',
        locExclude: 'Exclude location',
        locInclude: 'Location',
        locSourceExclude: 'Exclude location (source ID)',
        locSourceInclude: 'Location (source ID)',
        nfzHersteller: 'Commercial vehicle manufacturer',
        nfz: 'Commercial vehicle',
        lang: 'Language',
        views: 'Default',
        takeinAsc: 'Oldest first',
        takeinDesc: 'Newest first',
    },
    footer: {
        co2DatLink: 'CO₂ guide',
        pshButton: "Open the manufacturer's product safety instructions",
        textPsh:
            'Product security information: Manufacturer (((car.productSecurity.tradename))) | Address: (((car.productSecurity.firm))), (((car.productSecurity.address))) | Phone: (((car.productSecurity.phone))) | Mail: (((car.productSecurity.email)))',
        textWLTP:
            'The information is provided in accordance with the Passenger Car Energy Consumption Labeling Ordinance. The stated values were determined in accordance with the prescribed measurement procedure WLTP (World Harmonized Light Vehicles Test Procedure). The fuel consumption and C02 emissions of a car depend not only on the efficient use of fuel by the car, but also on driving style and other non-technical factors. C02 is the main greenhouse gas responsible for global warming. A guide to the fuel consumption and C02 emissions of all new passenger car models offered in Germany is available free of charge in electronic form at any point of sale in Germany where new passenger cars are displayed or offered for sale. The guide is also available at the Internet address {0}. Only the C02 emissions caused by the operation of the car are stated. C02 emissions caused or avoided by the production and provision of the passenger car and the fuel or energy source are not taken into account when determining C02 emissions in accordance with the WLTP.',
    },
    menu: {
        activeConfig: 'Active configuration',
        currentVersion: 'Active version',
        dark: 'Dark mode',
        disabled: 'Disabled',
        heading: 'Main menu',
        light: 'Light mode',
    },
    modules: {
        [Modules.Aktionsslider]: 'Sale Slider',
        [Modules.ConfigListing]: 'Configurations',
        [Modules.ErweiterteSchnellsuche]: 'Advanced Quick Search',
        [Modules.Fahrzeugliste]: 'Vehicle list',
        [Modules.Fahrzeugslider]: 'Vehicle slider',
        [Modules.Fahrzeugsuche]: 'Vehicle search',
        [Modules.Finanzierungsansicht]: 'Financing view',
        [Modules.Install]: 'Installation documentation',
        [Modules.Menu]: 'Menu',
        [Modules.Print]: 'Exposé',
        [Modules.Schnellsuche]: 'Quick search',
        [Modules.Standorte]: 'Locations',
    },
    opening: {
        closed: 'closed',
        openTill: 'open until {0}',
        openAtToday: 'closed, opens at {0}',
        openAtTomorrow: 'closed, opens tomorrow at {1}',
        openAtOtherDay: 'closed, opens {0} at {1}',
        verkauf: 'Sale',
        service: 'Service',
        werkstatt: 'Workshop',
    },
    time: {
        days: {
            '0': 'Sunday',
            '1': 'Monday',
            '2': 'Tuesday',
            '3': 'Wednesday',
            '4': 'Thursday',
            '5': 'Friday',
            '6': 'Saturday',
            singular: 'day',
            plural: 'days',
        },
        month: {
            plural: 'months',
            singular: 'month',
        },
        week: {
            plural: 'weeks',
            singular: 'week',
        },
        year: {
            plural: 'years',
            singular: 'year',
        },
    },
    validation: {
        invalid: 'Invalid!',
        invalidEntry: 'Invalid value! Allowed: {0}',
        maxCarPrice: 'The price is greater than the vehicle price',
        minPrice: 'Price too low',
        required: 'Required',
        wholeNumber: 'Only whole numbers allowed',
    },
};

export default enUS;
